import React from 'react';

import {message} from 'antd';
import {observable} from "mobx";
import {http, addVisitLog, history} from 'libs';

class Store {
  @observable records = [];
  @observable orderId = '';
  @observable isFetching = false;
  @observable selectedRowKeys = []
  @observable selectedCustomKeys = []
  @observable userAddRecords = []
  @observable record = {
    brand: ""
    , created_at: ""
    , customerId: 0
    , deliveryDate: null
    , desc: ""
    , extraSn: null
    , factoryCode: ""
    , formats: ""
    , id: ''
    , isMeasure: false
    , name: ""
    , number: 1
    , productId: null
    , catalog: "Sale"
    , isEdit: true
  }

  //还有个获取的， GET ， 返回的 {default: [], custom: []} 这样的数据结构
  fetchRecords = () => {
    this.records.length === 0 && (this.isFetching = true)

    return http.get('/javaApi/front/cart/listAll')
      .then(res => {
        // this.records = res.data.result
        this.records = res.data.result['default']
        this.userAddRecords = res.data.result['custom']
        // this.userAddRecords.map(v => v['isEdit'] = false)
      })
      .finally(() => this.isFetching = false)
  };

  //加入购车 （商品列表、详情 ）
  addRecord = (id, catalog, number = 1) => {
    const params = {productId: id, catalog: catalog, number: number};
    addVisitLog({
      pageName: "加入购物车",
      fromPageUrl: window.referrerUrl,
      pageUrl:`${window.location.origin}${history.location.pathname}`,
      eventCode: "AddCart",
      eventName: "加入购物车",
      content: JSON.stringify(params)
    })
    const key = 'updateCart';
    message.loading({content: 'Loading...', key});
    return http.post('/javaApi/front/cart/edit', params)
      .then(() => {
        message.success({content: '已加入购物车!', key, duration: 2});
      })
  }

  // 更新数量和项目编号
  updateRecord = (index, record, val, name = 'number') => {
    const key = 'updateCart';
    message.loading({content: 'Loading...', key});
    return http.post('/javaApi/front/cart/edit', {
      id: record['id'],
      number: name === 'number' ? val : record.number,
      // extraSn: name === 'extraSn' ? val : record.extraSn,
      // isMeasure: name === 'isMeasure' ? val : record.isMeasure,
    })
      .then(() => {
        // this.records[index][name] = val
        this.fetchRecords();
        message.success({content: '修改成功!', key, duration: 1});
      })
  }

  // 添加、更新用户自己添加的商品
  updateUserAddRecord = (data, index = 0) => {
    const key = 'userAddCart';
    message.loading({content: 'Loading...', key});

   return http.post('/javaApi/front/cart/edit', data)
      .then(() => {
        // this.userAddRecords[index] = data
        // this.userAddRecords[index]['isEdit'] = false
        this.fetchRecords()
        message.success({content: '修改成功!', key, duration: 1});
      })
  }

  //删除
  delRecord = (id, index = -1, type = 0) => {
    const key = 'deleteCart';
    message.loading({content: 'Loading...', key});
    http.post('/javaApi/front/cart/delete',{id:id})
      .then(() => {
        // if (type) {
        //   this.userAddRecords.splice(index, 1)
        // } else if (index !== -1) {
        //   this.records.splice(index, 1)
        // }
        this.fetchRecords()
        message.success({content: '已删除!', key, duration: 2});
      })
  }

    //删除所有购物车
    delRecordAll = () => {
      const key = 'deleteCart';
      message.loading({content: 'Loading...', key});
      http.post('/javaApi/front/cart/deleteAll')
        .then(() => {
          this.fetchRecords()
          message.success({content: '已删除!', key, duration: 2});
        })
    }

  //提交求购
  postInquiry = () => {
    if (this.selectedRowKeys.length === 0 && this.selectedCustomKeys.length === 0) {
      message.warn('请选择商品')
      return
    }

    return http.post('/javaApi/front/cart/createInquiry', {ids: [].concat(this.selectedCustomKeys, this.selectedRowKeys)})
      .then(res => {
        this.selectedRowKeys=[]
        this.selectedCustomKeys=[]
        this.orderId = res.data.result
        message.success('提交求购成功')
        this.fetchRecords()
      })
  }


}

export default new Store()

// brand: "鱼跃"
// brand_code: "QLC"
// created_at: "2020-10-22 12:29:41"
// desc: null
// details: "<p></p><div class="media-wrap image-wrap"><img src="http://public-buket.oss-cn-hangzhou.aliyuncs.com/clinical/2010/ad68f1bb6bef40ee922d7f8ef8d42c92.png"/></div><p></p>"
// factory_code: "YHT-101"
// formats: "套"
// id: 23
// is_hot: false
// lease_able: false
// lease_price: 0
// main_images: [,…]
// material_code: "QLC*YHT-101*SXH5"
// name: "耳温枪"
// sale_able: true
// sale_price: 635
// status: "1"
// stock_number: 0
// supplier_code: "SXH5"
// thumb: "http://public-buket.oss-cn-hangzhou.aliyuncs.com/clinical/2010/5681d2a7a367484c8e09a00ccf60ec4d.png"
// number: 1
// product_id: "23"
// type: 1
